import { LayerSet } from "types/types";

import { MapContent } from "components/map/MapContent";
import { RenderSelectedLayer } from "components/map/RenderSelectedLayer";
import { ScenarioLegendControl } from "components/map/legend/scenarioLegend/ScenarioLegendControl";

interface Props {
  layerSet: LayerSet;
}

export function LayerSetDialogMap(props: Props) {
  const { layerSet } = props;

  return (
    <MapContent>
      <RenderSelectedLayer layerSet={layerSet} />
      <ScenarioLegendControl position="bottomright" layerSet={layerSet} />
    </MapContent>
  );
}
